export function enableContigency(usuario, enableForm) {
  let data = {
    usuario_Atualizacao: usuario,
    justificativa: enableForm.justify,
    numero_Chamado: enableForm.numeroChamado,
  };

  return data;
}

export function disableContigency(usuario, enableForm) {
  console.log(enableForm);
  let data = {
    usuario_Atualizacao: usuario,
    justificativa: enableForm.justify,
    numero_Chamado: enableForm.chamado,
  };

  return data;
}
